import { cn } from "@/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"

const skeletonVariants = cva(
  "relative overflow-hidden rounded-2xl transition-theme",
  {
    variants: {
      variant: {
        default: "bg-gradient-to-br from-muted/40 via-muted/20 to-muted/40",
        soft: "bg-gradient-to-br from-accent/5 via-background to-accent/5",
        accent: "bg-gradient-to-br from-primary/5 via-primary/10 to-primary/5",
      },
      shimmer: {
        true: "before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/10 before:to-transparent",
        false: "animate-pulse",
      },
    },
    defaultVariants: {
      variant: "default",
      shimmer: true,
    },
  }
)

export interface SkeletonProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {}

function Skeleton({
  className,
  variant,
  shimmer,
  ...props
}: SkeletonProps) {
  return (
    <div
      className={cn(skeletonVariants({ variant, shimmer }), className)}
      {...props}
    />
  )
}

export { Skeleton, skeletonVariants }
